import React, { useState } from 'react'

import { Dropdown, ToolbarButton } from '@fourthwall/components'
import { FilterIcon } from '@fourthwall/icons'

import { FilterDropdownBox } from './components/FilterDropdownBox'
import { GroupTitle } from './components/GroupTitle'
import type { Props } from './types'

export const FilterDropdown = ({ activityIndicator, content, onReset, onSubmit }: Props) => {
  const [isOpen, setOpen] = useState(false)

  const handleReset = () => {
    onReset()
    setOpen(false)
  }

  const handleSubmit = () => {
    onSubmit()
    setOpen(false)
  }

  return (
    <Dropdown
      isOpen={isOpen}
      content={
        <FilterDropdownBox content={content} onReset={handleReset} onSubmit={handleSubmit} />
      }
      position="bottom-end"
      maxWidth={500}
      onClose={() => setOpen(false)}
    >
      <ToolbarButton
        label="Filter"
        icon={FilterIcon}
        activityIndicator={activityIndicator}
        onClick={() => setOpen((status) => !status)}
      />
    </Dropdown>
  )
}

FilterDropdown.GroupTitle = GroupTitle
